export default [
  /* Leads */
  {
    path: '/leads',
    name: 'Leads',
    component: () => import('@/pages/lead/Leads'),
    children: [
      {
        path: 'gerenciar',
        name: 'Leads.Gerenciar',
        meta: {
          descricao: 'Gerenciar Leads'
        },
        component: () => import('@/pages/lead/Gerenciar')
      },
      {
        path: 'formularioCaptura',
        name: 'Leads.Link',
        meta: {
          descricao: 'Formulario de Captura'
        },
        component: () => import('@/pages/lead/GerarLink')
      }
    ]
  }
]
